import React from "react";

export const MyPage = () => {
  return (<>My Page</>);
};
